/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const Syntax = {
  Lark: "lark",
  Regex: "regex",
} as const;
export type Syntax = ClosedEnum<typeof Syntax>;

export type GrammarFormat = {
  type: "grammar";
  definition: string;
  syntax: Syntax;
};

/** @internal */
export const Syntax$inboundSchema: z.ZodNativeEnum<typeof Syntax> = z
  .nativeEnum(Syntax);
/** @internal */
export const Syntax$outboundSchema: z.ZodNativeEnum<typeof Syntax> =
  Syntax$inboundSchema;

/** @internal */
export const GrammarFormat$inboundSchema: z.ZodType<
  GrammarFormat,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("grammar"),
  definition: z.string(),
  syntax: Syntax$inboundSchema,
});
/** @internal */
export type GrammarFormat$Outbound = {
  type: "grammar";
  definition: string;
  syntax: string;
};

/** @internal */
export const GrammarFormat$outboundSchema: z.ZodType<
  GrammarFormat$Outbound,
  z.ZodTypeDef,
  GrammarFormat
> = z.object({
  type: z.literal("grammar"),
  definition: z.string(),
  syntax: Syntax$outboundSchema,
});

export function grammarFormatToJSON(grammarFormat: GrammarFormat): string {
  return JSON.stringify(GrammarFormat$outboundSchema.parse(grammarFormat));
}
export function grammarFormatFromJSON(
  jsonString: string,
): SafeParseResult<GrammarFormat, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GrammarFormat$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GrammarFormat' from JSON`,
  );
}
